module.exports = {"notFound":"Nenalezeno","exists":"Již ve skupině","duplicated":"Duplicitní"}